import { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Button, Dialog } from 'components';
import { launchPrivider } from 'services';

export const DialogRemoveVinc = ({ open, onClose, rowData }) => {
  if (!open) return null;

  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await launchPrivider.removeVincClientsOpv({ idCadastro: rowData?.idCadastro });
      toast.success('Vinculo removido com sucesso!');
      onClose();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Erro ao remover vinculo!');
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Dialog open={open}>
      <Dialog.Title onClose={onClose}>Remover vinculo</Dialog.Title>
      <Dialog.Content>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              align='center'
              variant='h2'
              style={{ fontSize: '24px', fontWeight: 'bold', paddingBottom: '1rem' }}
            >
              Deseja realmente excluir esse vinculo?
            </Typography>
          </Grid>
        </Grid>
      </Dialog.Content>
      <Dialog.Actions>
        <Button color='secondary' fullWidth loading={isLoading} onClick={onClose}>
          Não
        </Button>
        <Button fullWidth onClick={handleSubmit} loading={isLoading}>
          Sim
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};
